import * as React from 'react';
import styled from 'styled-components';

import { COLORS, ComponentTextStyle} from '../styles';
import { ComponentSStyling } from '../styles';

export type SkipToContentProps = {
  children: React.ReactNode;
};

const SkipToContentLink = styled.a`
  ${props => ComponentSStyling(ComponentTextStyle.Bold, COLORS.getColor('black', props.theme))}

  text-decoration: underline;
`;

const SkipToContentWrapper = styled.div`
  text-decoration: none;
  z-index: -1000;
  height: 0px;
  overflow-x: hidden;

  &:focus-within {
    height: auto;
    padding: 16px;
    z-index: 100000;
    flex: 1 0 auto;
    background: ${props => COLORS.getColor('accent2_200', props.theme)};
  }

  @media print {
    display: none;
  }
`;

const SkipToContent: React.FunctionComponent<SkipToContentProps> = ({ children }) => {
  return (
    <SkipToContentWrapper>
      <SkipToContentLink href="#main">{children}</SkipToContentLink>
    </SkipToContentWrapper>
  );
};

export default SkipToContent;
